import { Button } from "primereact/button";

const IconButton = ({
  handleClick,
  color = "success",
  icon = "plus",
  outlined = false,
  text = false,
  disabled = false,
  size = "medium",
  type = "button",
  tooltip = "",
  id = "",
  tooltipPosition = "top"
}) => {
  const customIcon = typeof icon === "string" ? "pi pi-" + icon : icon;
  const buttonClass = `p-button-rounded p-button-${color}${
    outlined ? " p-button-outlined" : ""
  }${text ? " p-button-text" : ""}`;
  const buttonStyle =
    size === "smaller"
      ? { height: "1.5rem", width: "1.5rem" }
      : size === "small"
      ? { height: "2rem", width: "2rem" }
      : size === "big"
      ? { height: "3rem", width: "3rem" }
      : { height: "2.4rem", width: "2.4rem" };

  return (
    <>
      <Button
        id={id}
        tooltip={tooltip}
        tooltipOptions={{ position: `${tooltipPosition}` }}
        type={type}
        icon={customIcon}
        className={buttonClass}
        style={buttonStyle}
        onClick={handleClick}
        disabled={disabled}
        aria-label="icon-button"
      />
    </>
  );
};

export default IconButton;
